import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { GreenTickSvg } from 'components/icons';
import { Icon, Bullet } from 'atoms';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: ${displayState?.background};
    cursor: pointer;
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Checkbox',
      renderIf: ({ selected }) => selected,
      displayValue: ({ color }) => GreenTickSvg({ width: 9, height: 7, color: color })
    },
    {
      component: Bullet,
      name: 'Title',
      renderIf: ({ selected }) => !selected,
      displayValue: ({ }) => ' ',
      displayState: ({ color }) => ({ color, size: '8px' }),
    },
  ],
})